export interface IWalletInfo {
  _id?: string;
  balance: number;
  currentMonthExpenses: number;
  previousMonthExpenses: number;
  totalCreditLimit: number;
  username?: string;
  createdAt?: Date;
  updatedAt?: Date;
}
